export const PRIMARY_COLOR = "#373737";
export const SECONDARY_COLOR = "#42c7fd";
// export const SECONDARY_COLOR = "#f77516";
